import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Input,
  Paper,
  DialogContentText,
} from "@mui/material";
import Draggable from "react-draggable";
import PropTypes from "prop-types";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import {
  atualizarClientes,
  buscarClientesPorID,
  buscarClientesPorTexto,
  buscarTodosClientes,
  cadastraClientes,
  deletarCliente,
  deletarClientes,
} from "../../services/api-empresas.service";
import ClientesForm from "src/forms/ClientesForm";

function DebounceInput(props) {
  const { handleDebounce, debounceTimeout, ...rest } = props;

  const timerRef = React.useRef();

  const handleChange = async (event) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(async () => {
      const textoBusca = event.target.value;

      try {
        const response = await buscarTodosClientes();

        handleDebounce(response.data.grupoEconomico);
      } catch (err) {
        if (err.response) {
          if (err.response.status === 404) handleDebounce([]);
          else alert(err.response.data.mensagem);
        } else {
          alert("Erro desconhecido");
        }
      }
    }, debounceTimeout);
  };

  return <Input {...rest} onChange={handleChange} />;
}

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

DebounceInput.propTypes = {
  debounceTimeout: PropTypes.number.isRequired,
  handleDebounce: PropTypes.func.isRequired,
};

const Clientes = () => {
  const inicialState = {
    empresa: {
      idEmpresa: null,
      razaoSocial: "",
      cnpj: "",
      dtAbertura: undefined,
      dtBaixa: undefined,
      inscricaoEstadual: "",
      inscricaoMunicipal: "",
      ativo: false,
      controlador: false,
      servicos: [],
      idUsuarioParceiro: null,
    },
    contato: [{ descricao: "", telefone: "", celular: "", email: "" }],
    endereco: {
      logradouro: "",
      numero: "",
      complemento: "",
      cep: "",
      bairro: "",
      codIbge: 0,
    },
    gruposEconomicos: [
      {
        idGrupoEconomico: 0,
        inicioVinculo: undefined,
        finalVinculo: undefined,
      },
    ],
  };

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleOpenModalEditRow = async (rowData) => {
    rowData = await buscarClientesPorID(rowData.idEmpresa);
    setEditRowData(rowData.empresa);
    setOpenModal(true);
  };

  const handleOpenModal = () => {
    setEditRowData(inicialState);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    try {
      let certFile;
      let certFileName;

      if (data.empresa.certificadoFile) {
        const formFile = data.empresa.certificadoFile;
        certFile = new File([formFile], formFile.name, {
          type: formFile.type,
          lastModified: formFile.lastModified
        });
        certFileName = data.empresa.certificadoFileName + '';
      }
    
      delete data.empresa.certificadoFile;
      delete data.empresa.certificadoFileName;
      data.empresa.certificadoFileName = 
        (certFile)
          ? certFileName
          : null;

      if (data.empresa.idEmpresa) {
        const responseEdit = await atualizarClientes(
          data.empresa.idEmpresa,
          data, 
          certFile
        );
        setMsg(responseEdit.mensagem);
        setOpenSnackbarSucesso(true);
        handleCloseModal();
      } else {
        const responseNew = await cadastraClientes(data, certFile);
        setMsg(responseNew.mensagem);
        setOpenSnackbarSucesso(true);
        handleCloseModal();
      }
    } catch (error) {
      setMsg(error?.response?.data?.mensagem);
      setOpenSnackbarErro(true);
    }

    getData();
  };

  const handleDelete = async () => {
    //Deleta
    try {
      const responseDelete = await deletarCliente(editRowData.idEmpresa);
      setMsg(responseDelete.mensagem);

      getData();
    } catch (err) {
      if (err.response) {
        setMsg(err.response.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
    }

    handleCloseDialogExclusao();
    handleOpenSnackbarSucesso();
  };

  const columns = [
    { id: "idEmpresa", label: "ID", field: "idEmpresa" },
    { id: "cnpj", label: "CNPJ", field: "cnpj" },
    { id: "ativo", label: "Ativo", field: "ativo" },
    { id: "razaoSocial", label: "Razão Social", field: "razaoSocial" },
    { id: "telefone", label: "Telefone", field: "telefone" },
    { id: "celular", label: "Celular", field: "celular" },
    { id: "email", label: "E-mail", field: "email" },
    { id: "dtAbertura", label: "Data", field: "dtAbertura" },
  ];

  const getData = async () => {
    setLoading(true);
    let response = await buscarTodosClientes();
    response.empresas = await response.empresas.map((empresa) => {
      if (empresa.ContatoEmpresaORMs.length > 0) {
        empresa.telefone = empresa.ContatoEmpresaORMs[0].telefone || null;
        empresa.celular = empresa.ContatoEmpresaORMs[0].celular || null;
        empresa.email = empresa.ContatoEmpresaORMs[0].email || null;
        empresa.descricao = empresa.ContatoEmpresaORMs[0].descricao || null;
      } else {
        empresa.telefone = null;
        empresa.celular = null;
        empresa.email = null;
        empresa.descricao = null;
      }

      if (empresa.dtAbertura) empresa.dtAbertura = new Date(empresa.dtAbertura);

      return empresa;
    });
    setData(response.empresas);
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (err) {
        if (err.response) {
          setMsg(err.response.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
    };

    fetchData();
  }, [navigate]);

  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const [msg, setMsg] = useState("");

  const [openDialogExclusao, setOpenDialogExclusao] = React.useState(false);

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const [mask, setMask] = useState("");
  const defaultProps = {
    options: [],
    getOptionLabel: (option) => option.label,
  };
  const [cep, setCep] = useState("");

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await buscarClientesPorTexto(event.target.value);
      response.empresa = await response.empresa.map((empresa) => {
        if (empresa.ContatoEmpresaORMs.length > 0) {
          empresa.telefone = empresa.ContatoEmpresaORMs[0].telefone || null;
          empresa.celular = empresa.ContatoEmpresaORMs[0].celular || null;
          empresa.email = empresa.ContatoEmpresaORMs[0].email || null;
          empresa.descricao = empresa.ContatoEmpresaORMs[0].descricao || null;
        } else {
          empresa.telefone = null;
          empresa.celular = null;
          empresa.email = null;
          empresa.descricao = null;
        }

        if (empresa.dtAbertura)
          empresa.dtAbertura = new Date(empresa.dtAbertura);
        return empresa;
      });
      setData(response.empresa);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setData([]);
      }
      setMsg(err.response.data.mensagem);
      handleOpenSnackbarErro();
    }
    setLoading(false);
  };

  //#region --------------- Template --------------

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={<Diversity3Icon fontSize="30px" />}
        headerTitle={"Clientes"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        modalButtonLabel={"Adicionar"}
      />

      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        onEditButtonClick={handleOpenModalEditRow}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "1200px",
            height: "508px",
            overflow: "hidden", // Adiciona esta linha para ocultar a barra de rolagem
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <Diversity3Icon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData?.empresa?.idEmpresa
                ? "Edição de Cliente"
                : "Cadastro de Cliente"}
            </h1>
          </div>
        </DialogTitle>
        <DialogContent>
          <ClientesForm
            clienteValues={Object.assign({}, editRowData)}
            onSubmit={handleSaveChanges}
            onClose={handleCloseModal}
            className={styles.popupContent}
          />
        </DialogContent>
        <DialogActions
          className={styles.botoesPopupGeral}
          style={{ marginBottom: "-10px" }}
        ></DialogActions>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir a empresa {editRowData.razaoSocial}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default Clientes;
